import React from 'react';
import image from "../../src/Background/polyglot logo.png"
import "../Style/Header.css"

function Header(props) {
    return (
        <div className = "header">
                <img src={image} alt={"logo"}/>
        </div>
    );
}

export default Header;